import React, { useEffect, useState } from 'react'

import { Tabs, Tab, Box } from '@mui/material'

import { Container } from '../../../components'
import { useAddRemovePropertyForms } from '../../../hooks/useAddRemovePropertyForms'
import { useUser } from '../../../hooks'
import { AddPropertyFormsPage } from './AddPropertyFormsPage'
import { RemovePropertyFormsPage } from './RemovePropertyFormsPage'

export const AdminFormsRoot = () => {
    const [activeTab, setActiveTab] = useState(ADD_PROPERTY_FORM_TAB)

    const { organization } = useUser()

    const {
        addPropertyFormList,
        removePropertyFormList,
        loadingState,
        getAddPropertyFormList,
        getRemovePropertyFormList,
        updateAddPropertyFormState,
        updateAddPropertyForm,
        updateRemovePropertyFormState,
        updateRemovePropertyForm,
    } = useAddRemovePropertyForms(organization)

    useEffect(() => {
        getAddPropertyFormList()
        getRemovePropertyFormList()
    }, [])

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue)
    }

    return (
        <Container style={{ flex: 1, flexDirection: 'column' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label="Add Property Forms" />
                    <Tab label="Remove Property Forms" />
                </Tabs>
            </Box>
            {activeTab === ADD_PROPERTY_FORM_TAB && (
                <AddPropertyFormsPage
                    addPropertyFormList={addPropertyFormList}
                    loading={loadingState.getAddPropertyFormList}
                    updateAddPropertyFormState={updateAddPropertyFormState}
                    updateAddPropertyForm={updateAddPropertyForm}
                />
            )}
            {activeTab === REMOVE_PROPERTY_FORM_TAB && (
                <RemovePropertyFormsPage
                    removePropertyFormList={removePropertyFormList}
                    loading={loadingState.getRemovePropertyFormList}
                    updateRemovePropertyFormState={
                        updateRemovePropertyFormState
                    }
                    updateRemovePropertyForm={updateRemovePropertyForm}
                />
            )}
        </Container>
    )
}

const ADD_PROPERTY_FORM_TAB = 0
const REMOVE_PROPERTY_FORM_TAB = 1
